export default __webpack_public_path__ + "13e66a8709ffa64f6b8b9b4c521a8569.svg";